import './lle_mandatory.css';
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { PROD } from '../../../../common/constants';
import { Container, Card, CardContent, Button, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ArrowBackIosNewIcon, ArrowForwardIosIcon } from '../../../../common/icons';

const MandatoryDetails = () => {
    const { t } = useTranslation();
    const [backButtonData, setBackButtonData] = useState();
    const [prevScreenData, setPrevScreenData] = useState();
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        setPrevScreenData(location.state.data)
        setSelectedApplicant(location.state.data.applicantType);

    }, [prevScreenData]);

    const onSubmit = (e) => {

        const dataForApi = {
            ...prevScreenData,

        }
        navigate(getLocalStorageItem('id_token') ? "/registrationHome/preregistration/lletermsCondition" : "/preregistration/lletermsCondition", { state: { data: dataForApi } });

    }


    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG12</p>}
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            {t('preReg.mandatoryRequirements')}
                        </Typography>
                        <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                            {t('main.one')}. {t('preReg.financialStrength')}:
                            <Typography variant="body2" gutterBottom>
                                {t('preReg.financialDescrip')}
                            </Typography>
                        </Typography>
                        <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                        {t('main.two')}. {t('preReg.mobileNetworkConnectivity')}:
                            <Typography variant="body2" gutterBottom>
                                {t('preReg.mobileConnectivityDescrip')}
                            </Typography>
                        </Typography>
                        <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                        {t('main.three')}. {t('preReg.environmentSustainability')}:
                            <div style={{ marginLeft: "3%" }}>
                                <Typography variant="subtitle2" gutterBottom>
                                    i. {t('preReg.wildlifeCorridor')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.wildlifeCorridorDescrip')}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    ii. {t('preReg.ecologicalBufferZone')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.ecologicalBufferZoneDescrip')}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    iii. {t('preReg.forest')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.forestDescrip')}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    iv. {t('preReg.soil')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.soilDescrip')}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    v. {t('preReg.water')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.waterDescrip')}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    vi. {t('preReg.flora&fauna')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.flora&faunaDescrip')}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    vii. {t('preReg.archaeologicalSite')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.archaeologicalSiteDescrip')}
                                </Typography>
                            </div>
                        </Typography>
                        <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                        {t('main.four')}. {t('preReg.social')}:
                            <div style={{ marginLeft: "3%" }}>
                                <Typography variant="subtitle2" gutterBottom>
                                    i. {t('preReg.forcedEviction')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.forcedEvictionDescrip')}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom>
                                    ii. {t('preReg.localEmployment')}:
                                </Typography>
                                <Typography style={{ display: "inline" }} variant="body2" gutterBottom>
                                    {t('preReg.localEmploymentDescrip')}
                                </Typography>
                            </div>
                        </Typography>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" startIcon={<ArrowBackIosNewIcon />} onClick={() => (navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/llepowerDetails' : '/preregistration/llepowerDetails', { state: { data: prevScreenData } }))}>{t('preReg.previous')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" endIcon={<ArrowForwardIosIcon />} onClick={(e) => onSubmit(e)}>{t('preReg.next')}</Button>
                </Box>
            </Container>
        </>
    );
}


export default MandatoryDetails;
